import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import loader from '../../assets/Images/loader.gif'
import businessIcon from "../../assets/Images/offers.PNG"
import hotelIcon from "../../assets/Images/city.png"
import * as api from '../../api_function';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const CardListProfi = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [proFiUserAccess, setProFiUserAccess] = useState("");
    const [pgUserAccess, setPgUserAccess] = useState("");
    const [hotelUserAccess, setHotelUserAccess] = useState("");
    const navigate = useNavigate();

    const redirectDashboardPage = () => {
        navigate("/dashboard");
    };

    useEffect(() => {
        const fetchData = async () => {

            try {
                setIsLoading(true);
                const fetchUseraccessData = await api.getAllUsersRoles();
                // console.log("fetchUseraccessData",fetchUseraccessData?.data?.profi);
                setProFiUserAccess(fetchUseraccessData?.data?.profi);
                setPgUserAccess(fetchUseraccessData?.data?.pg);
                setHotelUserAccess(fetchUseraccessData?.data?.hotel)
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, [])

    const redirectSalesBusinessPG = async () => {
        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "validateuser",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                UserName: sessionStorage.getItem('userEmail')=="P_Maya.Iyer"?"P_Maya.Iyer@spectra.co":sessionStorage.getItem('userEmail'),
                UserPass: sessionStorage.getItem('password'),
                UserType: "S",
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            const responseData = await response.json();
            // console.log("UserStatus",responseData);
            // console.log("Sales Business valid user API Response:", responseData);
            if (responseData && responseData.Response && responseData.Status === "Success" &&
                responseData.Response.data.UserStatus == "Enabled") {
                // console.log('Actual Data:', responseData.Response.data);
                sessionStorage.setItem("RoleProFi", responseData ? responseData.Response.data.Role : "")
                sessionStorage.setItem("PrimaryEmailProFi", responseData ? responseData.Response.data.PrimaryEmail : "")
                sessionStorage.setItem("empId", responseData ? responseData?.Response?.data?.EmployeeID : "")

                const userEmail = responseData.Response.data.PrimaryEmail?.toLowerCase();
                const pgEmailsLower = pgUserAccess.map(email => email.toLowerCase());

                if (pgEmailsLower.includes(userEmail)) {
                    navigate("/businessCardListPG");
                } else {
                    toast.warning("Access Denied", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }

                if (responseData.Response.data.UserStatus == "Disabled") {
                    toast.warning("user disabled in crm", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
            }
            else {
                const errorMessage = (responseData && responseData.Response && responseData.Response.Message);
                //     toast.warning(`${errorMessage}`, {
                //       position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                //   });
                // navigate("/business");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const redirectSalesBusinessProWifi = async () => {

        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "validateuser",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                UserName: sessionStorage.getItem('userEmail')=="P_Maya.Iyer"?"P_Maya.Iyer@spectra.co":sessionStorage.getItem('userEmail'),
                UserPass: sessionStorage.getItem('password'),
                UserType: "S",
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            const responseData = await response.json();
            // console.log("UserStatus",responseData);
            // console.log("Sales Business valid user API Response:", responseData);
            if (responseData && responseData.Response && responseData.Status === "Success" &&
                responseData.Response.data.UserStatus == "Enabled") {
                // console.log('Actual Data:', responseData.Response.data);
                sessionStorage.setItem("RoleProFi", responseData ? responseData.Response.data.Role : "")
                sessionStorage.setItem("PrimaryEmailProFi", responseData ? responseData.Response.data.PrimaryEmail : "")
                sessionStorage.setItem("empId", responseData ? responseData?.Response?.data?.EmployeeID : "")

                const userEmail = responseData.Response.data.PrimaryEmail?.toLowerCase();
                const prowifiEmailsLower = proFiUserAccess.map(email => email.toLowerCase());

                if ((prowifiEmailsLower.includes(userEmail) || responseData.Response.data.Role == "BDR Team")) {
                    navigate("/businessCardListProWiFi");
                } else {
                    toast.warning("Access Denied", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }

                if (responseData.Response.data.UserStatus == "Disabled") {
                    toast.warning("user disabled in crm", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
            }
            else {
                const errorMessage = (responseData && responseData.Response && responseData.Response.Message);
                //     toast.warning(`${errorMessage}`, {
                //       position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                //   });
                // navigate("/business");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const redirectSalesBusinessHotel = async () => {

        try {
            setIsLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "validateuser",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                UserName: sessionStorage.getItem('userEmail')=="P_Maya.Iyer"?"P_Maya.Iyer@spectra.co":sessionStorage.getItem('userEmail'),
                UserPass: sessionStorage.getItem('password'),
                UserType: "S",
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            const responseData = await response.json();
            // console.log("UserStatus",responseData);
            // console.log("Sales Business valid user API Response:", responseData);
            if (responseData && responseData.Response && responseData.Status === "Success" &&
                responseData.Response.data.UserStatus == "Enabled") {
                // console.log('Actual Data:', responseData.Response.data);
                sessionStorage.setItem("RoleProFi", responseData ? responseData.Response.data.Role : "")
                sessionStorage.setItem("PrimaryEmailProFi", responseData ? responseData.Response.data.PrimaryEmail : "")
                sessionStorage.setItem("empId", responseData ? responseData?.Response?.data?.EmployeeID : "")

                const userEmail = responseData.Response.data.PrimaryEmail?.toLowerCase();
                const hotelEmailsLower = hotelUserAccess.map(email => email.toLowerCase());

                if (hotelEmailsLower.includes(userEmail)) {
                    navigate("/businessCardListHotel");
                } else {
                    toast.warning("Access Denied", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }

                if (responseData.Response.data.UserStatus == "Disabled") {
                    toast.warning("user disabled in crm", {
                        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
                    });
                }
            }
            else {
                const errorMessage = (responseData && responseData.Response && responseData.Response.Message);
                //     toast.warning(`${errorMessage}`, {
                //       position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                //   });
                // navigate("/business");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span className='' style={{ cursor: 'pointer' }} onClick={redirectDashboardPage}>
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className='p-1 m-3'>PROFI</span>
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: "60px" }}>
                {isLoading && (
                    <div className="loader-wrapper">
                        <div className="loader">
                            <img src={loader} alt='loading....' ></img>
                        </div>
                    </div>
                )}
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    <div className="col" onClick={redirectSalesBusinessPG}>
                        <div className="card mb-2 mt-2 ">
                            <div className="m-1" style={{ display: "inline-flex" }}>
                                {/* <div className="card-icon">
                                    <img src={businessIcon} alt="icon" width="30" className='dashboard-icon'></img>
                                   
                                </div> */}
                                <div className="m-1">
                                    <div className="card-body">
                                        <p className="card-text card-title overflow-hidden">SALES : BUSINESS - PG</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* SALES : BUSINESS  Pro WIFI Card */}
                    <div className="col" onClick={redirectSalesBusinessProWifi}>
                        <div className="card mb-2 mt-2 ">
                            <div className="m-1" style={{ display: "inline-flex" }}>
                                {/* <div className="card-icon">
                                    <img src={businessIcon} alt="icon" width="30" className='dashboard-icon'></img>
                                </div> */}
                                <div className="m-1">
                                    <div className="card-body">
                                        <p className="card-text card-title overflow-hidden">SALES : BUSINESS - OFFICE</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* SALES : BUSINESS Hotel Card */}
                    {/* {(userName == "manager1" || userName == "Manager1") && ( */}
                    <div className="col" onClick={redirectSalesBusinessHotel}>
                        <div className="card mb-2 mt-2 ">
                            <div className="m-1" style={{ display: "inline-flex" }}>
                                {/* <div className="card-icon">
                                    <img src={hotelIcon} alt="icon" width="30" className='dashboard-icon'></img>
                                </div> */}
                                <div className="m-1">
                                    <div className="card-body">
                                        <p className="card-text card-title overflow-hidden">SALES : BUSINESS - HOTEL</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* )} */}
                </div>
            </div>
        </>
    )
}

export default CardListProfi